import { render, staticRenderFns } from "./ExDxxl.vue?vue&type=template&id=c719ad12&scoped=true"
import script from "./ExDxxl.vue?vue&type=script&lang=js"
export * from "./ExDxxl.vue?vue&type=script&lang=js"
import style0 from "./ExDxxl.vue?vue&type=style&index=0&id=c719ad12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c719ad12",
  null
  
)

export default component.exports